import { portsEvent, profileTypeEndPoint, profileTypeEnum, tableMapData } from "@components/templates/Profile/ProfileHeader/profile-enum";
import ProfileTable from "@components/templates/Profile/ProfileTable";
import { cachingPanelData } from "@containers/PortProfile/utils/constant";
import { globalCountryDetailsDictionary } from "@core/global/global-country-details";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { getEventName, getUserActivePlan } from "@helpers/profileHelper";
import { ladingCachingHandler, unLadingCachingHandler } from "@redux/PortProfile/portProfileSlice";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
const PortTable = ({ tableName }) => {
  const [isLoaderActive, setIsLoaderActive] = useState(true);
  const [tradingPartnerData, setTradingPartnerData] = useState([]);
  const [tradingPartnerCount, setTradingPartnerCount] = useState(null);
  const [tradingPartnerMustNotInclude, setTradingPartnerMustNotInclude] = useState([]);
  const [sortOrderValue, setSortOrderValue] = useState("desc");
  const [selectedTradingPartner, setSelectedTradingPartner] = useState([]);
  const [clearSelectedTradingPartner, setClearSelectedTradingPartner] = useState(false);
  const [tradingPartnerCurrentPage, setTradingPartnerCurrentPage] = useState(1);
  const [tradingPartnerRange, setTradingPartnerRange] = useState({ from: 1, to: 100 });
  const { portId, portName } = useParams();
  const { tabDetails, profileRedirectionId, ladingCaching, unladingCaching } = useSelector((state) => state.portProfile);
  const { activeTabId, activePanelId } = tabDetails;
  const { search: searchUrlParams, pathname } = useLocation();
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.userDetails.userData);
  const globalPlanCheck = userData?.planIds?.find((planId) => planId?.navigate === "search" && planId?.productId === globalCountryDetailsDictionary?.global_plan?.product_id);

  const downloadEvent = () => {
    trademoTrackingEvents(getEventName(profileTypeEnum.ports, portsEvent[activeTabId]?.tabDownload), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
  };

  const viewShipmentsEvent = () => {
    trademoTrackingEvents(getEventName(profileTypeEnum.ports, portsEvent[activeTabId]?.viewShipments), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
  };

  const companyRedirectionEvent = () => {
    trademoTrackingEvents(getEventName(profileTypeEnum.logistics, portsEvent[activeTabId]?.profileClick), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
  };

  useEffect(() => {
    setSelectedTradingPartner([]);
  }, [activePanelId, activeTabId]);
  const callTrendingPartners = (tradingPartnerData = [], tradingPartnerMustNotInclude = [], sortOrderValue = "desc", isPaginate) => {
    const requestPayload = {
      profile_type: profileTypeEnum.ports,
      _id: portId,
      category: activePanelId,
      sub_category: activeTabId,
      map_type: "",
      order: sortOrderValue,
      must_not: tradingPartnerMustNotInclude,
    };
    setIsLoaderActive(true);
    setClearSelectedTradingPartner(false);
    setTradingPartnerCurrentPage(1);
    if (cachingPanelData.lading === activePanelId && ladingCaching[activeTabId] && ladingCaching?.[activeTabId]?.sortOrderValue === sortOrderValue && !isPaginate) {
      let ladingCachingClone = JSON.parse(JSON.stringify(ladingCaching));
      const { tableData, tableCount, sortOrderValue, mergedMustNotIncludeTradingPartner } = ladingCachingClone[activeTabId];
      setTradingPartnerData(tableData);
      setTradingPartnerCount(tableCount);
      setTradingPartnerMustNotInclude(mergedMustNotIncludeTradingPartner);
      setSortOrderValue(sortOrderValue);
      setIsLoaderActive(false);
    } else if (cachingPanelData.unlading === activePanelId && unladingCaching[activeTabId] && unladingCaching?.[activeTabId]?.sortOrderValue === sortOrderValue && !isPaginate) {
      let unLadingCachingClone = JSON.parse(JSON.stringify(unladingCaching));
      const { tableData, tableCount, sortOrderValue, mergedMustNotIncludeTradingPartner } = unLadingCachingClone[activeTabId];
      setTradingPartnerData(tableData);
      setTradingPartnerCount(tableCount);
      setTradingPartnerMustNotInclude(mergedMustNotIncludeTradingPartner);
      setSortOrderValue(sortOrderValue);
      setIsLoaderActive(false);
    } else {
      axios
        .post(profileTypeEndPoint.ports.getShipperDetails, requestPayload)
        .then((res) => {
          const { data, status } = res.data;
          if (!!status && status.toLocaleUpperCase() === "success".toLocaleUpperCase()) {
            const tableData = data[tableMapData[activeTabId].data];
            const tableCount = data[tableMapData[activeTabId].count];
            const mustNot = data.must_not;
            if (!!data && !!tableData && tableData.length !== 0) {
              let mergedMustNotIncludeTradingPartner = tradingPartnerMustNotInclude.concat(mustNot);
              let mergedTradingPartnerData = tradingPartnerData.concat(tableData);
              if (tableCount !== undefined && tableCount < 100) {
                setTradingPartnerRange({ from: 1, to: tableCount });
              }
              setTradingPartnerData(mergedTradingPartnerData);
              setTradingPartnerCount(tableCount);
              setTradingPartnerMustNotInclude(mergedMustNotIncludeTradingPartner);
              setSortOrderValue(sortOrderValue);
              if (cachingPanelData.lading === activePanelId) {
                let ladingCachingClone = JSON.parse(JSON.stringify(ladingCaching));
                ladingCachingClone[activeTabId] = { tableData: mergedTradingPartnerData, tableCount: tableCount, sortOrderValue: sortOrderValue, mergedMustNotIncludeTradingPartner: mergedMustNotIncludeTradingPartner };
                dispatch(ladingCachingHandler(ladingCachingClone));
              } else if (cachingPanelData.unlading === activePanelId) {
                let unLadingCachingClone = JSON.parse(JSON.stringify(unladingCaching));
                unLadingCachingClone[activeTabId] = { tableData: mergedTradingPartnerData, tableCount: tableCount, sortOrderValue: sortOrderValue, mergedMustNotIncludeTradingPartner: mergedMustNotIncludeTradingPartner };
                dispatch(unLadingCachingHandler(unLadingCachingClone));
              }
            } else {
              setTradingPartnerData([]);
              setTradingPartnerCount(0);
              setTradingPartnerMustNotInclude([]);
              setSortOrderValue("desc");
            }
            setIsLoaderActive(false);
          } else {
            toast.error("Something went wrong. Please try again after sometime !!!");
          }
        })
        .catch(() => {
          setIsLoaderActive(false);
          toast.error("Something went wrong. Please try again later !!!");
        });
    }
  };

  return (
    <ProfileTable
      tableName={tableName}
      callTrendingPartners={callTrendingPartners}
      isLoaderActive={isLoaderActive}
      tradingPartnerData={tradingPartnerData}
      tradingPartnerCount={tradingPartnerCount}
      sortOrderValue={sortOrderValue}
      tradingPartnerMustNotInclude={tradingPartnerMustNotInclude}
      tradingPartnerRange={tradingPartnerRange}
      setTradingPartnerRange={setTradingPartnerRange}
      category={activePanelId}
      subCategory={activeTabId}
      profileName={portName}
      profileType={profileTypeEnum.ports}
      profileId={portId}
      selectedTradingPartner={selectedTradingPartner}
      setSelectedTradingPartner={setSelectedTradingPartner}
      clearSelectedTradingPartner={clearSelectedTradingPartner}
      setClearSelectedTradingPartner={setClearSelectedTradingPartner}
      tradingPartnerCurrentPage={tradingPartnerCurrentPage}
      setTradingPartnerCurrentPage={setTradingPartnerCurrentPage}
      downloadEvent={downloadEvent}
      dataSource={dataSource}
      viewShipmentsEvent={viewShipmentsEvent}
      companyRedirectionEvent={companyRedirectionEvent}
      profileRedirectionId={profileRedirectionId}
      globalPlan={globalPlanCheck?.navigate === "search" ? true : false}
    />
  );
};

export default PortTable;
